<template>
  <b-modal
      v-model="show"
      v-if="show"
      centered
      hide-footer
      title="افزودن اطلاعات جسمانی جدید"
      :no-close-on-backdrop="true"
      size="md"
  >
    <b-row>
      <b-col md="6">
        <b-form-group
            label="قد"
            label-for="Height"
        >
          <b-form-input
              id="Height"
              v-model="form.Height"
              type="number"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>
      <b-col class="col-md-6">
        <b-form-group
            label="وزن"
            label-for="Weight"
        >
          <b-form-input
              id="Weight"
              v-model="form.Weight"
              type="number"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>
      <b-col class="col-md-6">
        <b-form-group
            label="سن"
            label-for="Age"
        >
          <b-form-input
              id="Age"
              v-model="form.Age"
              type="number"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>
      <b-col class="col-md-6">
        <b-form-group
            label="جنسیت"
            label-for="Gender"
        >
          <v-select
              v-model="form.Gender"
              dir="rtl"
              :reduce="x => x.value"
              label="text"
              input-id="Gender"
              :clearable="false"
              :options="enums('Gender')"
          />
        </b-form-group>
      </b-col>
      <b-col class="col-md-6">
        <b-form-group
            label="میزان فعالیت"
            label-for="ActivityLevel"
        >
          <v-select
              v-model="form.ActivityLevel"
              dir="rtl"
              :reduce="x => x.value"
              label="text"
              input-id="ActivityLevel"
              :clearable="false"
              :options="enums('ActivityLevel')"
          />
        </b-form-group>
      </b-col>
      <!--<b-col class="col-md-6">
        <b-form-group label="بیماری ها" label-for="SicknessIds">
          <Sickness v-model="form.SicknessIds" :multiple="true" />
        </b-form-group>
      </b-col>-->
      <b-col class="col-md-6">
        <b-form-group
            label="دوران شیر دهی "
            label-for="LactationType"
        >
          <v-select
              v-model="form.LactationType"
              dir="rtl"
              :reduce="x => x.value"
              label="text"
              input-id="LactationType"
              :clearable="false"
              :options="enums('Lactation')"
          />
        </b-form-group>
      </b-col>
      <b-col class="col-md-6">
        <b-form-group
            label="دور مچ"
            label-for="Wrist"
        >
          <b-form-input
              id="Wrist"
              v-model="form.Wrist"
              type="number"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>
      <b-col class="col-md-6">
        <b-form-group
            label="دور شکم"
            label-for="Belly"
        >
          <b-form-input
              id="Belly"
              v-model="form.Belly"
              type="number"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>
      <b-col class="col-md-6">
        <b-form-group
            label="دور کمر"
            label-for="Waist"
        >
          <b-form-input
              id="Waist"
              v-model="form.Waist"
              type="number"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>
      <b-col class="col-md-6">
        <b-form-group
            label="دور سینه"
            label-for="Chest"
        >
          <b-form-input
              id="Chest"
              v-model="form.Chest"
              type="number"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>
      <b-col class="col-md-6">
        <b-form-group
            label="دور بازو"
            label-for="Arm"
        >
          <b-form-input
              id="Arm"
              v-model="form.Arm"
              type="number"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>

      <b-col class="col-md-6">
        <b-form-group
            label="دور باسن"
            label-for="Hip"
        >
          <b-form-input
              id="Hip"
              v-model="form.Hip"
              type="number"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>
      <b-col class="col-md-6">
        <b-form-group
            label="دور ران"
            label-for="Thigh"
        >
          <b-form-input
              id="Thigh"
              v-model="form.Thigh"
              type="number"
              autocomplete="off"
          />
        </b-form-group>
      </b-col>

    </b-row>
    <div class="text-center mt-2">
      <b-overlay :show="loading" rounded spinner-small class="d-inline-block">
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            :disabled="loading"
            @click="submit"
        >
          ذخیره
        </b-button>
      </b-overlay>
      <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="outline-secondary"
          @click="$emit('update:show', !show)"
      >
        انصراف
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import Sickness from "@/tools/sickness.vue";

export default {
  name: "addPhysicalInfoForm",
  components: { Sickness },
  props: {
    show: { type: Boolean, default: false },
    data: { type: Object, default: null },
    userId: { type: [String, Number], default: '' }
  },
  data() {
    return {
      loading: false,
      form: {}
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        if (!val) this.form = this.createForm()
        if (this.data) this.form = this.createForm(this.data)
      }
    },
    data: {
      handler(val) {
        if (val) {
          // this.form = this.createForm(val)
        }
      }
    }
  },
  methods: {
    submit() {
      let requiredFields = ['Height', 'Weight', 'Wrist', 'Gender', 'Age', 'ActivityLevel', 'LactationType']
      let index = requiredFields.findIndex(field => this.form[field] === '')
      if (index !== -1) return
      this.loading = true
      this.$http.post(this.$api.user.addUserBodyHistory, this.form).then(() => {
        this.loading = false
        this.$emit('update:show', !this.show)
        this.$emit('update')
      }).finally(() => {
        this.loading = false
      })
    },
    createForm(data) {
      let form = {
        UserId: this.userId,
        Height: '',
        Weight: '',
        Wrist: '',
        Gender: '',
        Age: '',
        ActivityLevel: '',
        LactationType: '',
        // SicknessIds: [],
        Chest: '',
        Belly: '',
        Arm: '',
        Waist: '',
        Hip: '',
        Thigh: '',
      }
      if (data) {
        form.Height = data.Height
        form.Weight = data.Weight
        form.Wrist = data.Wrist
        form.Gender = data.Gender
        form.Age = (Number(this.$moment().format('YYYY')) - Number(data.BirthYear))
        form.ActivityLevel = data.ActivityLevel
        form.LactationType = data.LactationType
        // form.SicknessIds = data.SicknessIds
        form.Chest = data.Chest
        form.Belly = data.Belly
        form.Arm = data.Arm
        form.Waist = data.Waist
        form.Hip = data.Hip
        form.Thigh = data.Thigh
      }
      return form
    }
  }
}
</script>